import { buildDemandeService } from '@/features/services/demande/buildDemandeService.ts'
import { EndPointProformaDemande } from '@/features/services'
import type {
  DemandeProformaDTO,
  LovProformaDTO,
  RemboursementProformaDto,
} from '@/features/api/extranet/dto/Demande/PROFORMA'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'
import type { IPagedResponse } from '@/features/api/extranet'

const INIT_DEFAULT: RequestInit = { sablier: true, dialogMode: 'retry' } as const

async function loadDrEligibles(id: number, init?: RequestInit): Promise<RemboursementProformaDto[]> {
  init = {
    ...INIT_DEFAULT,
    ...init,
  }

  // Charge les dr
  const fetch = useFetch('extranet')
  const baseUrl = EndPointProformaDemande.endPoints.endPointEntite
  const response = await fetch(`${baseUrl}/${id}/dr?pageSize=1000`, init)
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IPagedResponse<RemboursementProformaDto>

  return result.data
}

const demandeService = buildDemandeService<'MODEL_PROFORMA', LovProformaDTO>({
  location: EndPointProformaDemande.location,
  normaliserData: normaliserData,
})

export default {
  ...demandeService,
  loadDrEligibles,
}

function normaliserData(data: DemandeProformaDTO) {
  data.niveauPermission = 'Ecriture'
  //data.typeDemande ??= TypeDemandeDossier
  data.fichiers ??= []
  data.ribsEligibles ??= []
  return data
}
